/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Mathematics17Inputs */

const en__field__enum_studyprograms_study_mathematics17 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Mathematics17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematics`)
};

const de__field__enum_studyprograms_study_mathematics17 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Mathematics17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematik`)
};

/**
* | output |
* | --- |
* | "Mathematics" |
*
* @param {_Field__Enum_Studyprograms_Study_Mathematics17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_mathematics17 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Mathematics17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Mathematics17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_mathematics17(inputs)
	return de__field__enum_studyprograms_study_mathematics17(inputs)
});
export { _field__enum_studyprograms_study_mathematics17 as "_field__enum_studyPrograms_STUDY_MATHEMATICS" }